import React, { useEffect, useState } from 'react'
import EmployeesTable from './employees-table/EmployeesTable'
import PrimaryButton from '../../../components/button/PrimaryButton'
import ModalContainer from '../../../components/modal-container/ModalContainer'
import { useToggle } from '../../../hooks'
import FormInputsFields from '../cip/components/add-client-page/FormInputsFields'
import { useForm } from 'react-hook-form'
import { joiResolver } from '@hookform/resolvers/joi'
import { EMPLOYEE_CENTER_FORM_KEYS, employeeCenterSchema } from './EmployeeCenter.config'
import { EMPLOYEE_DEPARTMENTS } from '../../../config/departments'
import { EMPLOYEE_DESIGNATIONS } from '../../../config/designations'
import { useAddEmployeeMutation, useDeleteEmployeeDetailsMutation, useUpdateEmployeeDetailsMutation } from '../../../services/kmt/employeeCenter'
import { toast } from 'react-hot-toast'

const EmployeeCenter = () => {
  const [displayAddModal, setDisplayAddModal] = useToggle(false)
  const [displayDeleteModal, setDisplayDeleteModal] = useToggle(false)
  const [isEdit, setIsEdit] = useState(false)
  const [addEmployeeToDB] = useAddEmployeeMutation()
  const [deleteEmployeeDetails] = useDeleteEmployeeDetailsMutation()
  const [updateEmployeeDetails] = useUpdateEmployeeDetailsMutation()
  const [employeeDetailsOnEdit, setEmployeeDetailsOnEdit] = useState({
    [EMPLOYEE_CENTER_FORM_KEYS.DEPARTMENT]: "",
    [EMPLOYEE_CENTER_FORM_KEYS.EMAIL]: "",
    [EMPLOYEE_CENTER_FORM_KEYS.FIRST_NAME]: "",
    [EMPLOYEE_CENTER_FORM_KEYS.LAST_NAME]: "",
    _id: ""
  })
  const { handleSubmit, formState: { errors }, reset, control, setValue, getValues } = useForm({
    resolver: joiResolver(employeeCenterSchema),
    defaultValues: {
      [EMPLOYEE_CENTER_FORM_KEYS.FIRST_NAME]: "",
      [EMPLOYEE_CENTER_FORM_KEYS.LAST_NAME]: "",
      [EMPLOYEE_CENTER_FORM_KEYS.DEPARTMENT]: "Client Services",
      [EMPLOYEE_CENTER_FORM_KEYS.EMAIL]: "",
    }
  });

  const handleFormSubmit = async (data) => {
    let designation = ""
    const { department, firstName, lastName, email } = data
    if (department === EMPLOYEE_DEPARTMENTS.SALES) {
      designation = EMPLOYEE_DESIGNATIONS.SALES_ASSOCIATE
    }
    else if (department === EMPLOYEE_DEPARTMENTS.CLIENT_SERVICES) {
      designation = EMPLOYEE_DESIGNATIONS.CLIENT_SERVICES
    }
    else if (department === EMPLOYEE_DEPARTMENTS.KNOWLEDGE_MANAGEMENT) {
      designation = EMPLOYEE_DESIGNATIONS.KMT_ASSOCIATE
    }
    const payload = {
      firstName,
      lastName,
      designation,
      department
    }

    let response = null
    if (isEdit) {
      payload.email = employeeDetailsOnEdit.email
      payload._id = employeeDetailsOnEdit._id
      response = await updateEmployeeDetails(payload)
    }
    else {
      payload.email = email
      response = await addEmployeeToDB(payload)
    }
    if (!response.error) {
      toast.success(isEdit ? "Employee Details have been edited successfully" : "Employee added successfully")
      setDisplayAddModal()
    }
  }
  useEffect(() => {
    setValue(EMPLOYEE_CENTER_FORM_KEYS.EMAIL, employeeDetailsOnEdit[EMPLOYEE_CENTER_FORM_KEYS.EMAIL])
    setValue(EMPLOYEE_CENTER_FORM_KEYS.FIRST_NAME, employeeDetailsOnEdit[EMPLOYEE_CENTER_FORM_KEYS.FIRST_NAME])
    setValue(EMPLOYEE_CENTER_FORM_KEYS.LAST_NAME, employeeDetailsOnEdit[EMPLOYEE_CENTER_FORM_KEYS.LAST_NAME])
    setValue(EMPLOYEE_CENTER_FORM_KEYS.DEPARTMENT, employeeDetailsOnEdit[EMPLOYEE_CENTER_FORM_KEYS.DEPARTMENT])
  }, [employeeDetailsOnEdit])
  const handleDeleteEmployeeDetails = async () => {
    const response = await deleteEmployeeDetails(employeeDetailsOnEdit._id)
    if (!response.error) {
      toast.success("User details has been deleted successfully")
      setDisplayDeleteModal()
    }
  }
  return (
    <div className='p-5'>
      <ModalContainer visible={displayDeleteModal} onHide={setDisplayDeleteModal} draggable={false} headerClassName="text-white" header="Delete Employee Details" style={{ width: "50%" }}>
        <div className="flex flex-column justify-content-center align-items-center p-5">
          <h5 className='mb-4'>Are you sure you want to delete {employeeDetailsOnEdit.firstName}'s details?</h5>
          <div className="flex align-items-center gap-3">
            <PrimaryButton variant="flat">Cancel</PrimaryButton>
            <PrimaryButton onClick={handleDeleteEmployeeDetails} variant="outline">Delete</PrimaryButton>
          </div>
        </div>
      </ModalContainer>
      <ModalContainer draggable={false} headerClassName="text-white" visible={displayAddModal} onHide={setDisplayAddModal} header={isEdit ? "Edit Employee Details" : "Add Employee"} style={{ width: "50%" }}>
        <form onSubmit={handleSubmit(handleFormSubmit)}>

          <div className="grid">
            <div className="col-6">
              <FormInputsFields
                name={EMPLOYEE_CENTER_FORM_KEYS.FIRST_NAME}
                label="First Name*"
                type='input'
                control={control}
                errors={errors}
              />
            </div>
            <div className="col-6">
              <FormInputsFields
                name={EMPLOYEE_CENTER_FORM_KEYS.LAST_NAME}
                label="Last Name*"
                type='input'
                control={control}
                errors={errors}
              />
            </div>
            <div className="col-6">
              <FormInputsFields
                name={EMPLOYEE_CENTER_FORM_KEYS.EMAIL}
                label="Email*"
                type='input'
                control={control}
                errors={errors}
                disabled={isEdit}
              />
            </div>
            <div className="col-6">
              <FormInputsFields
                name={EMPLOYEE_CENTER_FORM_KEYS.DEPARTMENT}
                label="Department*"
                type='dropdown'
                control={control}
                errors={errors}
                options={Object.getOwnPropertyNames(EMPLOYEE_DEPARTMENTS).map(key => EMPLOYEE_DEPARTMENTS[key])}
              />
            </div>
            {/* <div className="col-6">
              <FormInputsFields
                name={EMPLOYEE_CENTER_FORM_KEYS.DESIGNATION}
                label="Designation*"
                type='dropdown'
                control={control}
                errors={errors}
                options={Object.getOwnPropertyNames(EMPLOYEE_DESIGNATIONS).map(key => EMPLOYEE_DESIGNATIONS[key])}
              />
            </div> */}
          </div>
          <div className="flex justify-content-center">
            <PrimaryButton>{isEdit ? "Edit" : "Add"}</PrimaryButton>
          </div>
        </form>

      </ModalContainer>
      <h2 className='mb-2'>Employee Center</h2>
      <div className="flex justify-content-end mb-4">
        <PrimaryButton onClick={() => { setIsEdit(false); reset(); setDisplayAddModal(); }}>Add Employee</PrimaryButton>
      </div>

      <EmployeesTable setDisplayDeleteModal={setDisplayDeleteModal} setIsEdit={setIsEdit} setDisplayAddModal={setDisplayAddModal} setEmployeeDetailsOnEdit={setEmployeeDetailsOnEdit} />
    </div>
  )
}

export default EmployeeCenter